import $ from 'jquery';
import { h } from 'preact';
import { useMachineState } from '../../core/stent/preact/use-machine-state';
import { formatMoney } from '../../core/shopify/format-money';
import { CartDrawerIO } from './io';
import { CartDrawerItem } from './item';
import { SALE_DEFAULTS } from '../../core/typescript/sale';
const locale = {
    subtotal: 'Subtotal',
    freeShippingAtCheckout: 'Shipping, taxes and discounts calculated at checkout.',
    shippingAtCheckout: 'Taxes and discounts calculated at checkout.',
    checkout: 'Checkout',
    giftCta: 'SELECT GIFT OPTIONS',
    itemCountZero: 'Your cart is currently empty',
    itemCountOne: 'Your Shopping Bag',
    itemCountTwo: 'Your Shopping Bag',
    itemCountOther: 'Your Shopping Bag',
    qtyLabel: 'Quantity',
    reduceQty: 'Reduce quantity',
    increaseQty: 'Increase quantity',
    freeShipping: 'You’ve Earned Complimentary Shipping!',
    giftNoteNotice: 'Gift message added. Prices won’t be on shipping invoice.'
};
const container = $('#js-cart-drawer');
const rawIo = container.find('script[type="application/json"]').first().text() || '{}';
const { sale  } = CartDrawerIO.create(JSON.parse(rawIo));
export const App = function({ machine , moneyFormat ='{{ amount }}' , giftBoxesTooltipTitle , giftBoxesDescriptions  }) {
    const { name , error , contents: cart  } = useMachineState(machine);
    const drawerTitle = name === 'Failure' ? 'Error' : cart == null ? 'Updating…' : cart.item_count === 0 ? locale.itemCountZero : cart.item_count === 1 ? locale.itemCountOne : cart.item_count === 2 ? locale.itemCountTwo : locale.itemCountOther.replace('888', cart.item_count.toString(10));
    const closeIcon = h('svg', {
        width: '16',
        height: '16',
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 20 20',
        fill: '#11294a'
    }, h('path', {
        d: 'M16 1.05659L14.9433 0L8 6.94332L1.05668 0L0 1.05659L6.94337 7.99995L0 14.9433L1.05668 15.9999L8 9.05659L14.9433 15.9999L16 14.9433L9.05663 7.99995L16 1.05659V1.05659Z'
    }));
    const hasSaleItems = cart != null && cart.item_count > 0 && cart.items.some((item)=>{
        return item.properties != null && item.properties['Sale'] != null;
    });
    return h('div', {
        className: 'CartDrawer'
    }, h('div', {
        className: 'CartDrawer-content'
    }, h('header', {
        className: 'CartDrawer-header'
    }, h('div', {
        className: 'CartDrawer-title'
    }, h('h2', {
        id: 'cart-drawer-title',
        className: 'CartDrawer-titleInner'
    }, drawerTitle), h('button', {
        className: 'CartDrawer-close js-offcanvas-close',
        id: 'js-offcanvas-cartclose',
        'data-drawer-name': 'cart',
        ariaLabel: 'Close cart'
    }, h('div', {
        className: 'o-placeholder'
    }, closeIcon))), h('div', {
        className: 'CartDrawer-titleLink',
        html: 'test'
    })), h('ul', {
        className: 'CartDrawer-items'
    }, ((cart === null || cart === void 0 ? void 0 : cart.items) || []).map(function(item) {
        return h('li', {
            key: item.key,
            className: 'CartDrawer-item'
        }, h(CartDrawerItem, {
            item,
            moneyFormat,
            changeQuantity: machine.changeQuantity,
            giftBoxesTooltipTitle,
            giftBoxesDescriptions,
            sale: sale !== null && sale !== void 0 ? sale : SALE_DEFAULTS
        }));
    })), h('div', {
        className: 'nosto_element',
        id: 'minicart-placement'
    })), h('div', {
        className: 'CartDrawer-summary'
    }, h('div', {
        className: 'CartDrawer-subtotalContainer'
    }, [
        h('div', {
            className: 'CartDrawer-subtotalLabel',
            innerHTML: locale.subtotal
        }),
        h('div', {
            className: 'CartDrawer-subtotal'
        }, formatMoney((cart === null || cart === void 0 ? void 0 : cart.total_price) || 0, moneyFormat))
    ]), h('div', {
        className: hasSaleItems && (sale === null || sale === void 0 ? void 0 : sale.enabled) && sale.cart_message ? 'CartDrawer-salesWrapper --show ' : 'CartDrawer-salesWrapper --hide'
    }, [
        h('i', {
            className: 'Cart-salesIcon'
        }),
        h('p', {}, sale && sale.cart_message || '')
    ]), h('div', {
        className: 'CartDrawer-buttonWrapper'
    }, [
        h('button', {
            className: 'js-offcanvas-trigger-gift CartDrawer-giftboxButton o-button',
            'aria-controls': 'gift-drawer',
            ariaExpanded: 'false',
            innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_9721_434)"><path d="M9.47084 1.70871C9.9912 1.24304 10.6411 0.725098 11.4724 0.725098C12.3037 0.725098 12.9201 1.3718 12.9201 2.1705C12.9201 2.95855 12.2885 3.59751 11.5026 3.61397V3.6159H9.28623C8.94616 3.6159 7.83203 3.63043 7.83203 3.63043C7.83203 3.63043 8.39126 2.67586 9.47192 1.71064L9.47084 1.70871Z" stroke="#13294B" stroke-miterlimit="10"/><path d="M6.5274 1.70871C6.00704 1.24304 5.35713 0.725098 4.52586 0.725098C3.69458 0.725098 3.07812 1.3718 3.07812 2.1705C3.07812 2.95855 3.70969 3.59751 4.49563 3.61397V3.6159H6.71201C7.05208 3.6159 8.1662 3.63043 8.1662 3.63043C8.1662 3.63043 7.60699 2.67586 6.52632 1.71064L6.5274 1.70871Z" stroke="#13294B" stroke-miterlimit="10"/><path d="M14.8528 3.63062H1.14844V7.37618H14.8528V3.63062Z" stroke="#13294B"/><path d="M13.769 14.5286H2.23047V7.37598H13.769V14.5286Z" stroke="#13294B"/><path d="M8 3.74658V14.413" stroke="#13294B"/></g><defs><clipPath id="clip0_9721_434"><rect width="15" height="16" fill="transparent" transform="translate(0.5)"/></clipPath></defs></svg>'
        }, locale.giftCta)
    ]), // Container for additional checkout buttons moved from body
    cart && cart.item_count > 0 && h('div', {
        className: 'js-additional-checkout-buttons-drawer-placement CartDrawer-additionalCheckout'
    }), h('div', {
        className: 'CartDrawer-buttonWrapper'
    }, [
        h('a', {
            className: 'CartDrawer-checkoutButton o-button js-cart-button',
            href: '/checkout'
        }, locale.checkout)
    ]), (cart === null || cart === void 0 ? void 0 : cart.note) && h('p', {
        className: 'CartDrawer-gift-note-notice'
    }, locale.giftNoteNotice), h('div', {
        className: 'CartDrawer-error'
    }, error ? error.message : null)));
};
